export default (state = [], action) => {
  switch (action.type) {
    case 'COST_TRACKER':
      return action.payload;
    default:
      return state;
  }
};
